<my-bill-odb-page-base-structure
  [billingDocument]="billingDocument"
  [hasCommonHeader]="hasDataAvailable"
  [customTitle]="'bills.cover.identifierLabels.thirdParty' | translate"
>
  <!--///////////////   LEFT Column content   //////////////////-->
  <ng-container leftColumnContent *ngIf="hasDataAvailable">
    <div class="panel rs-no-padding" *ngIf="hasError">
      <lib-generic-message-box [messageType]="MessageBoxTypesEnum.Error">
        <ng-container Title>{{
          'bills.category.thirdParty.level4.errorTitle' | translate
        }}</ng-container>
        <p Content>
          {{ 'bills.category.thirdParty.level4.errorMessage' | translate }}
        </p>
      </lib-generic-message-box>
    </div>

    <ng-container *ngIf="!hasError">
      <div class="rs-panel-big rs-bg-c2" *ngIf="isFetching">
        <p></p>
        <lib-spinner></lib-spinner>
        <p></p>
      </div>
      <ng-container *ngIf="!isFetching">
        <div class="rs-panel-big rs-bg-c2">
          <p class="rs-tit4">
            <span class="rs-flex">
              <span class="rs-padding-right1"
                ><i
                  class="icon-Smartphone icon-lh rs-txt-s7"
                  aria-hidden="true"
                ></i
              ></span>
              {{ productSplitIdentifier }}
            </span>
          </p>
          <p data-cy="myBillOdbThirdPartyLvl4SectionDescription">
            <strong>{{ selectedSection.description }}</strong>
          </p>

          <div class="rs-flex-row" *ngFor="let cdrDetail of cdrDetails">
            <div class="rs-flex-column">
              <p
                class="rs-txt-primary"
                data-cy="myBillOdbThirdPartyLvl4ItemDescription"
              >
                <strong>{{ cdrDetail.destination }}</strong>
                <br /><span class="rs-txt-details">{{
                  cdrDetail.timeStamp | date : 'dd/MM/yyyy'
                }}</span>
              </p>
            </div>
            <div class="rs-flex-columns">
              <p *ngIf="cdrDetail.amount" class="rs-font-pxB">
                <px-currency-amount
                  [amount]="cdrDetail.amount"
                ></px-currency-amount>
              </p>
            </div>
          </div>
        </div>
        <div
          class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
          my-bill-odb-total
          [amount]="selectedSection.amount"
        ></div>
      </ng-container>
    </ng-container>
  </ng-container>
</my-bill-odb-page-base-structure>
